module.exports = __webpack_public_path__ + "img/cash.aa95bf07.jpg";